import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { View } from 'react-native';
import { getTestId } from '../../../../utils';
export var DraggableNotch = _ref => {
  var visible = _ref.visible,
    containerStyle = _ref.containerStyle,
    panResponder = _ref.panResponder,
    notchStyle = _ref.notchStyle,
    _ref$testID = _ref.testID,
    testID = _ref$testID === void 0 ? 'DraggableNotch' : _ref$testID;
  return _jsx(_Fragment, {
    children: visible && _jsx(View, Object.assign({
      style: containerStyle
    }, panResponder === null || panResponder === void 0 ? void 0 : panResponder.panHandlers, getTestId(testID), {
      children: _jsx(View, {
        style: notchStyle
      })
    }))
  });
};